<template>
  <span class="insights-ai-pill">
    <span class="material-symbols-rounded hi-14">auto_awesome</span>
    AI-powered
  </span>
</template>

<script>
// Sole home of the AI branding; both the label and the icon are expected to change.
export default {
  name: 'InsightsAiPill',
};
</script>
